import React, { useState, useEffect } from 'react';
import { showSuccess, showError } from '../services/reactToastify';
import axiosDotnet from '../services/axiosDotnet';

export default function EditTaskModal({ task, isOpen, onClose, onTaskUpdated }) {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        status: 'TODO',
        assignedTo: '',
        assignedUserName: '',
        dueDate: ''
    });

    useEffect(() => {
        if (task) {
            setFormData({
                title: task.Title || task.title || '',
                description: task.Description || task.description || '',
                status: task.Status || task.status || 'TODO',
                assignedTo: task.AssignedTo || '',
                assignedUserName: task.AssignedUserName || '',
                dueDate: task.DueDate ? new Date(task.DueDate).toISOString().split('T')[0] : ''
            });
        }
    }, [task]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axiosDotnet.put(`/api/tasks/${task.id || task.Id}`, {
                title: formData.title,
                description: formData.description,
                status: formData.status,
                assignedTo: formData.assignedTo || null,
                assignedUserName: formData.assignedUserName || null,
                dueDate: formData.dueDate || null
            });

            showSuccess("Task updated successfully!");
            onTaskUpdated();
            onClose();
        } catch (err) {
            showError("Failed to update task");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[70] p-4">
        <div className="bg-zinc-900 border border-zinc-700 rounded-3xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="p-6 border-b border-zinc-700">
                <h2 className="text-2xl font-semibold">Edit Task</h2>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto p-6 space-y-6">
                <div>
                    <label className="block text-sm text-zinc-400 mb-2">Title</label>
                    <input
                        type="text"
                        value={formData.title}
                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                        className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                        required
                    />
                </div>

                <div>
                    <label className="block text-sm text-zinc-400 mb-2">Description</label>
                    <textarea
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        rows={5}
                        className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none resize-y min-h-[120px]"
                    />
                </div>

                <div>
                    <label className="block text-sm text-zinc-400 mb-2">Status</label>
                    <select
                        value={formData.status}
                        onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                        className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                    >
                        <option value="TODO">To Do</option>
                        <option value="IN_PROGRESS">In Progress</option>
                        <option value="DONE">Done</option>
                    </select>
                </div>

                {/* <div>
                    <label className="block text-sm text-zinc-400 mb-2">Assigned To (User ID)</label>
                    <input
                        type="text"
                        value={formData.assignedTo}
                        onChange={(e) => setFormData({ ...formData, assignedTo: e.target.value })}
                        className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                        placeholder="GUID or leave empty"
                    />
                </div> */}

                <div>
                    <label className="block text-sm text-zinc-400 mb-2">Due Date</label>
                    <input
                        type="date"
                        value={formData.dueDate}
                        onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                        className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                    />
                </div>
            </div>

            {/* Footer Buttons */}
            <div className="p-6 border-t border-zinc-700 flex gap-4">
                <button
                    type="button"
                    onClick={onClose}
                    className="flex-1 py-4 border border-zinc-600 rounded-2xl hover:bg-zinc-800 transition-all"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="cursor-pointer flex-1 py-4 bg-violet-600 hover:bg-violet-500 rounded-2xl font-semibold transition-all"
                >
                    Update Task
                </button>
            </div>
        </div>
    </div>
    );
}